<template>
  <div>
    <md-toolbar class="md-primary toolbar">
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <span class="md-title"><a href="/home" class="brand-logo">SWARM.VIDEO</a></span>
        </div>

        <div class="md-toolbar-section-end">
          <md-button class="md-just-icon md-simple md-toolbar-toggle" v-on:click="showNavigation = true">
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </md-button>
          <div class="md-collapse">
            <a v-if="this.$router.history.current['path']=='/home'" href="#work">Try it for free</a>
            <a v-if="this.$router.history.current['path']=='/home'" href="#portal">Portal</a>
            <a v-if="this.$router.history.current['path']=='/home'" href="#footer">Contact</a>
            <router-link class="md-toolbar-a" to="dashboard" v-if="is_authenticated">Dashboard</router-link>
            <router-link class="md-toolbar-a" to="sources" v-if="is_authenticated">Websites</router-link>
            <router-link class="md-toolbar-a" to="streams" v-if="is_authenticated">Streams</router-link>
            <router-link class="md-toolbar-a" to="admin" v-if="is_authenticated && is_staff">Admin</router-link>
            <router-link class="md-toolbar-a" to="contacts" v-if="is_authenticated && is_staff">Contacts</router-link>
            <router-link class="md-toolbar-a" to="signup" v-if="!is_authenticated">SignUp</router-link>
            <router-link class="md-toolbar-a" to="login" v-if="!is_authenticated">Login</router-link>
            <div @click="logOut()">
              <router-link class="md-toolbar-a" to="" v-if="is_authenticated">LogOut</router-link>
            </div>
          </div>
        </div>
      </div>
    </md-toolbar>

    <md-drawer :md-active.sync="showNavigation" md-swipeable>
      <md-toolbar class="md-transparent" md-elevation="0">
        <span class="md-title">Swarm</span>
      </md-toolbar>

      <md-list>
        <div>
          <md-list-item v-if="this.$router.history.current['path']=='/home'" v-on:click="showNavigation = false">
            <sidebar-link to="" v-scroll-to="'#work'">
              <md-icon>slideshow</md-icon>
              <p class="md-list-p">Try it for free</p>
            </sidebar-link>
          </md-list-item>

          <md-list-item v-if="this.$router.history.current['path']=='/home'" v-on:click="showNavigation = false">
            <sidebar-link to="" v-scroll-to="'#portal'">
              <md-icon>how_to_reg</md-icon>
              <p class="md-list-p">Portal</p>
            </sidebar-link>
          </md-list-item>

          <md-list-item v-if="this.$router.history.current['path']=='/home'" v-on:click="showNavigation = false">
            <sidebar-link to="" v-scroll-to="'#footer'">
              <md-icon>send</md-icon>
              <p class="md-list-p">Contact</p>
            </sidebar-link>
          </md-list-item>
        </div>

        <div v-if="is_authenticated">
          <md-list-item v-on:click="showNavigation = false">
            <sidebar-link to="/dashboard">
              <md-icon>dashboard</md-icon>
              <p class="md-list-p">Dashboard</p>
            </sidebar-link>
          </md-list-item>

          <md-list-item v-if="!is_staff" v-on:click="showNavigation = false">
            <sidebar-link to="/sources">
              <md-icon>public</md-icon>
              <p>Add Websites</p>
            </sidebar-link>
          </md-list-item>

          <md-list-item v-on:click="showNavigation = false">
            <sidebar-link to="/streams">
              <md-icon>dashboard</md-icon>
              <p>Streams</p>
            </sidebar-link>
          </md-list-item>

          <md-list-item v-if="is_staff" v-on:click="showNavigation = false">
            <sidebar-link to="/admin">
              <md-icon>admin_panel_settings</md-icon>
              <p>Admin</p>
            </sidebar-link>
          </md-list-item>

          <md-list-item v-if="is_staff" v-on:click="showNavigation = false">
            <sidebar-link to="/contacts">
              <md-icon>email</md-icon>
              <p>Contacts</p>
            </sidebar-link>
          </md-list-item>
        </div>


        <md-list-item @click="logOut()" v-if="is_authenticated">
          <sidebar-link to="">
            <md-icon>exit_to_app</md-icon>
            <p class="md-list-p">LogOut</p>  
          </sidebar-link>
        </md-list-item>

        <md-list-item v-if="!is_authenticated" v-on:click="showNavigation = false">
          <sidebar-link to="/login">
            <md-icon>login</md-icon>
            <p class="md-list-p">Login</p>
          </sidebar-link>
        </md-list-item>
      </md-list>
    </md-drawer>
  </div>
  
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import Vue from 'vue'
import vueScrollto from 'vue-scrollto'
Vue.use(vueScrollto)


export default {
  name: 'NavBar',
  data: () => ({
    showNavigation: false
  }),
  methods: {
    ...mapActions(["SET_LOGOUT"]),
    logOut() {
      this.SET_LOGOUT();
      this.$router.push("home");
    },
    isMobile() {
      if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        return true
      } else {
        return false
      }
    }
  },
  computed: {
    ...mapGetters(["is_authenticated", "is_staff"])
  }
};
</script>

<style>
  .toolbar.md-primary {    
    background-color:  black !important;    
    position: fixed;    
  }
  .md-toolbar-section-end a {
    font-size: 1.2rem;
    color: #FFF !important;
    letter-spacing: 2px;
    display: block;
    font-weight: 300;
    padding: 0px 15px;
    padding-top: 0px;
    padding-right: 15px;
    padding-bottom: 0px;
    padding-left: 15px
  }

  .md-list-p {
    color: black !important;
  }

  .brand-logo {
      position: absolute !important;
      color: #fff !important;    
      font-size: 2.2em;
      letter-spacing: 7px;
      font-style: normal;
      font-weight: 100;
  }

  @media screen and (max-width: 600px) {
    .brand-logo {
      position: absolute !important;
      color: #fff !important;    
      font-size: 1.2em;
      letter-spacing: 7px;
      font-style: normal;
      font-weight: 100;
    }
}

</style>

<!-- 
<div class="wrapper" v-bind:class="{ 'nav-open': $sidebar.showSidebar }">
-    <side-bar>
-      <sidebar-link to="/sources" v-if="is_authenticated && !is_staff">
-        <md-icon>public</md-icon>
-        <p>Add Websites</p>
-      </sidebar-link>
-      <sidebar-link to="/dashboard" v-if="is_authenticated">
-        <md-icon>dashboard</md-icon>
-        <p>Dashboard</p>
-      </sidebar-link>
-      <sidebar-link to="/streams" v-if="is_authenticated">
-        <md-icon>dashboard</md-icon>
-        <p>Streams</p>
-      </sidebar-link>
-      <sidebar-link to="/signup" v-if="!is_authenticated">
-        <md-icon>person_add</md-icon>
-        <p>SignUp</p>
-      </sidebar-link>
-      <sidebar-link to="/login" v-if="!is_authenticated">
-        <md-icon>account_circle</md-icon>
-        <p>SignIn</p>
-      </sidebar-link>
-      <sidebar-link to="/admin" v-if="is_staff">
-        <md-icon>admin_panel_settings</md-icon>
-        <p>Admin</p>
-      </sidebar-link>
-      <sidebar-link to="/contacts" v-if="is_staff">
-        <md-icon>email</md-icon>
-        <p>Contacts</p>
-      </sidebar-link>
+  <div class="content">
+    <NavBar style="padding-bottom: 100px;"></NavBar>

-      <li class="md-list-item">
-        <a @click="logOut()"
-          v-if="is_authenticated"
-          href="#"
-          class="md-list-item-router md-list-item-container md-button-clean">
-          <div class="md-list-item-content md-ripple">
-            <i class="md-icon md-icon-font md-theme-default">exit_to_app</i>
-            <p>LogOut</p>
-          </div>
-        </a>
-      </li>
-    </side-bar> -->